import { env } from '../../config/env';

const getApiUrl = (): string => {
  if (env.server.deriveUrl) {
    const { host, protocol } = global.location;
    const domain = host.substring(host.lastIndexOf('.', host.lastIndexOf('.') - 1) + 1);
    return `${protocol}//api.${domain}`;
  } else {
    return `${env.server.apiUrl}`;
  }
};

export { getApiUrl };

